<div class="main-container" *ngIf="!faxService.hasOutgoingFaxNumbers() && !faxService.getOutgoingNumbersInProgress">
  <mat-card appearance="outlined">
    <mat-card-content>
      <p-message severity="warn">
        <p>
          You must assign your user to a fax number in order to view and send faxes.
          <span *ngIf="hasPhoneNumbersEditRight">
                Go to your <a class="btn-link" routerLink="/phone-numbers/list">Phone Numbers</a> to customize settings.
          </span>
          <span *ngIf="!hasPhoneNumbersEditRight">
                Contact your company administrator to setup messaging number.
          </span>
        </p>
        <p>
          If you don not have eFax service enabled for your company, contact your
          <a class="btn-link" role="button" (click)="openSupportWidget()">Customer Success Manager</a> to learn more
          about our eFax service.
        </p>
      </p-message>
    </mat-card-content>
  </mat-card>
</div>

<div
  class="main-container"
  style="max-width: 1000px"
  *ngIf="faxService.hasOutgoingFaxNumbers() && !faxService.getOutgoingNumbersInProgress"
>
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()" (change)="onFormChanged($event)">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">{{ serverError }}</div>

        <app-mat-simple-select
          [formControl]="getFormControl('numberFrom')"
          label="Send From"
          name="numberFrom"
          [selectItems]="faxNumbers"
          [submitted]="submitted"
        ></app-mat-simple-select>

        <app-mat-text-input
          [formControl]="getFormControl('fromName')"
          type="text"
          label="Sender Name"
          name="fromName"
          [submitted]="submitted"
          explanation="Sender Name"
        ></app-mat-text-input>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
          <!--<app-mat-phone-number-input fxFlex [formControl]="getFormControl('numberTo')"
                                      label="Send To"
                                      name="numberTo"
                                      placeholder="Enter phone number"
                                      [suffixIcon]="hasContactsModule && hasContactsViewRight ? 'person' : undefined"
                                      suffixTooltip="Search For Contacts"
                                      (onSuffixClicked)="onOpenContactsList($event)">
          </app-mat-phone-number-input>-->
          <app-mat-recipients-multiselect
            fxFlex
            [formControl]="contactsControl"
            [submitted]="submitted"
            [groups]="['Contacts']"
            label="Send To"
            placeholder="Search for contacts"
          >
          </app-mat-recipients-multiselect>
        </div>

        <app-mat-textarea-input
          formControlName="faxInternalNotes"
          label="Internal Notes"
          name="faxInternalNotes"
          [submitted]="submitted"
        ></app-mat-textarea-input>

        <app-mat-checkbox-input
          [formControl]="getFormControl('useCoverPage')"
          name="useCoverPage"
          (ngModelChange)="onUseCoverPageChange($event)"
          label="Use cover page"
        ></app-mat-checkbox-input>

        <mat-form-field appearance="outline" class="regular-form-field" *ngIf="useCoverPage">
          <mat-label>Cover page</mat-label>
          <mat-select (valueChange)="onFaxTemplateChange($event)" placeholder="Select fax template">
            <mat-option *ngFor="let item of coverPageTemplates" [value]="item" style="height: auto">
              <img
                *ngIf="item.previewImage"
                style="max-height: 100px; max-width: 80px"
                alt="cover page preview"
                [src]="item.previewImage"
              />
              <span style="padding-left: 15px">{{ item.name }}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div fxLayout="row" *ngIf="useCoverPage && selectedCoverPageTemplate && selectedCoverPageTemplate.id !== '-99'">
          <app-upload-fax
            fxFlex
            #fileInput1
            name="upload-fax1"
            id="upload-fax1"
            *ngIf="useCoverPage && selectedCoverPageTemplate && selectedCoverPageTemplate.id === '-1'"
            (validationError)="onFileValidationError($event)"
            (valueChanged)="onFileChanged1($event)"
          ></app-upload-fax>
          <app-fax-template
            fxFlex
            *ngIf="useCoverPage && selectedCoverPageTemplate && selectedCoverPageTemplate.id !== '-1'"
            [model]="selectedCoverPageTemplate"
            [parentData]="coverPageParentData"
            (valueChanged)="onFileChanged1($event)"
          ></app-fax-template>
        </div>

        <p-message severity="info">
          <span>
            You can add attachments in the following formats: PDF, RTF, JPG, JPEG, TIFF, TIF, CSV, HTML, TXT, PS,
            DOC, DOCX, XLSX. If more than 1 attachment are added, only PDF, JPG, or JPEG files are allowed.
          </span>
        </p-message>

        <div fxLayout="column">
          <mat-label class="label-text">Attachment</mat-label>
          <app-upload-fax
            #fileInput2
            name="upload-fax2"
            id="upload-fax2"
            (validationError)="onFileValidationError($event)"
            (valueChanged)="onFileChanged2($event)"
          ></app-upload-fax>
        </div>

        <div *ngIf="allowMergeFaxes">
          <div fxLayout="column" *ngFor="let attachment of additionalAttachments">
            <mat-label class="label-text">Attachment</mat-label>
            <app-upload-fax
              (validationError)="onFileValidationError($event)"
              (valueChanged)="onAdditionalAttachmentChanged($event, attachment)"
              [allowImages]="true"
            ></app-upload-fax>
          </div>
          <div>
            <button mat-stroked-button type="button" (click)="addAdditionalAttachment()">Add More Attachments</button>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button
          mat-raised-button
          type="submit"
          color="primary"
          matTooltip="Send Fax"
          *ngIf="hasEditAccess"
          [promiseBtn]="buttonSubmitPromise"
        >
          Send
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
